import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompletedComponent } from './completed.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
@NgModule({
  declarations: [CompletedComponent],
  imports: [CommonModule, 
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [CompletedComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class CompletedModule {}
